import React from 'react';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import Buttons2 from '../Settings/Buttons2';
import GenericCard from '../Shared/GenericCard';
import Toast from '../Toast';
import { exportJsonFile } from '../../components2/markingCriteria';
import {
  createSuccessCriteria,
  deleteSuccessCriteria,
  updateSuccessCriteriaSettings,
} from '../../service';
import { buildClonePayload } from '../../utils/subjects';
import checklistIcon from '../../static/img/markUnSelected.svg';

const SuccessCriteriaCard = ({
  successCriteria,
  isSelected,
  onSelect,
  onEdit,
  showCheckbox = true,
  showActions = true,
  isSystem = false,
  cloneSuccessCriteria = null,
  handleDownload,
  handleClone,
  handlePreview,
  handleOpenClick,
  disableNavigation = false,
}) => {
  const history = useHistory();

  const handleNavigate = (item) => {
    if (!disableNavigation) {
      history.push(`/tools/successcriterias/${item.id}`);
    }
  };

  const handleSuccessCriteriaDownload = (item) => {
    if (handleDownload) {
      handleDownload(item);
    } else {
      const extractedSuccessCriteria = {
        title: item.title,
        criterias: item.criterias,
      };
      exportJsonFile(
        extractedSuccessCriteria,
        extractedSuccessCriteria.title,
        'sc'
      );
    }
  };

  const handleSuccessCriteriaClone = () => {
    if (handleClone) {
      handleClone(successCriteria);
    } else if (cloneSuccessCriteria) {
      cloneSuccessCriteria(successCriteria);
    } else {
      const cleanedCriterias =
        successCriteria.criterias?.map((criteria) => ({
          objectives:
            criteria.objectives?.map((obj) => ({
              description: obj.description,
            })) || [],
          selectedStatus: null,
        })) || [];
      const newObject = buildClonePayload(successCriteria, [], {
        criterias: cleanedCriterias,
      });
      createSuccessCriteria(newObject)
        .then(() => {})
        .catch((error) => {
          console.error('Error cloning success criteria:', error);
        });
    }
  };

  const handleSuccessCriteriaPreview = () => {
    if (handlePreview) {
      handlePreview(successCriteria);
    }
  };

  const handleSuccessCriteriaOpen = () => {
    if (handleOpenClick) {
      handleOpenClick(successCriteria);
    } else if (successCriteria && !successCriteria.isSystem) {
      history.push(`/tools/successcriterias/${successCriteria.id}`);
    }
  };

  const handleSuccessCriteriaDelete = (id) => {
    deleteSuccessCriteria(id)
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        console.error('Error deleting success criteria:', error);
      });
  };

  const handleSuccessCriteriaSettings = async (id, settings) => {
    try {
      await updateSuccessCriteriaSettings(id, settings);
      toast(<Toast message="Settings saved successfully" />);
      window.location.reload();
    } catch (error) {
      console.error('Error updating success criteria settings:', error);
      toast(<Toast message="Failed to save settings" />);
    }
  };

  const badgeConfig = {
    icon: checklistIcon,
    label: 'Success Criterias',
  };

  const rightComponent = showActions ? (
    <Buttons2
      item={successCriteria}
      itemType="Success Criterias"
      onDownload={handleSuccessCriteriaDownload}
      onDelete={handleSuccessCriteriaDelete}
      onClone={handleSuccessCriteriaClone}
      onPreview={handleSuccessCriteriaPreview}
      onSettings={handleSuccessCriteriaSettings}
    />
  ) : null;

  return (
    <>
      <GenericCard
        item={successCriteria}
        type="successCriteria"
        isSelected={isSelected}
        onSelect={onSelect}
        onEdit={onEdit}
        showCheckbox={showCheckbox}
        showActions={showActions}
        isSystem={successCriteria?.isSystem}
        rightComponent={rightComponent}
        onNavigate={handleNavigate}
        onPreview={handleSuccessCriteriaPreview}
        badgeConfig={badgeConfig}
        disableNavigation={disableNavigation}
      />
    </>
  );
};

export default SuccessCriteriaCard;
